import { EnumerationBuilder } from 'utility-js-enumeration';
export const AuthTypeEnum = EnumerationBuilder.useDefinitionAsEnum('AuthTypeEnum', {
  NATIVE: {
    name: 'native',
    logoutMethod: 'delete',
    loginInterface: 'authentication.form'
  },
  CAS: {
    name: 'cas',
    logoutMethod: 'get',
    loginInterface: 'authentication.remote'
  },
  LDAP: {
    name: 'ldap',
    logoutMethod: 'delete',
    loginInterface: 'authentication.form'
  },
  SAML2: {
    name: 'saml2',
    logoutMethod: 'delete',
    loginInterface: 'authentication.remote'
  },
  SAML2_V2: {
    name: 'saml2v2',
    logoutMethod: 'get',
    loginInterface: 'authentication.remote'
  },
  INCOMMON: {
    name: 'incommon',
    logoutMethod: 'delete',
    loginInterface: 'authentication.remote'
  },
  CENTRAL: {
    name: 'central',
    logoutMethod: 'get',
    loginInterface: 'authentication.remote'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/types/auth_type_enum.ts